import { restJson } from "./httpClient";
import type { ConversationsResponse } from "../types";

const CONVERSATIONS_PATH = "/ai/insights/conversations";

export async function getUserConversations(): Promise<ConversationsResponse> {
  const response = await restJson<ConversationsResponse>(CONVERSATIONS_PATH);
  return {
    conversations: response.conversations.map((conversation) => ({
      id: conversation.id,
      title: conversation.title,
    })),
  };
}
